module.exports = __webpack_public_path__ + "sk-trip-wizard-card-bottom-left@2x.1M0jr9L4.png";